import { render, staticRenderFns } from "./realEstates.vue?vue&type=template&id=4e577a1a&scoped=true&"
import script from "./realEstates.vue?vue&type=script&lang=js&"
export * from "./realEstates.vue?vue&type=script&lang=js&"
import style0 from "./realEstates.vue?vue&type=style&index=0&id=4e577a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e577a1a",
  null
  
)

export default component.exports